import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, ShieldX, Loader2, Home } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifySeal() {
  const { token } = useParams();
  const [state, setState] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/sign/${token}/verify`)
      .then((r) => { setData(r.data); setState(r.data.valid ? "valid" : "invalid"); })
      .catch(() => setState("notfound"));
  }, [token]);

  return (
    <div className="min-h-screen bg-brand-softer flex items-center justify-center p-4">
      <div className="w-full max-w-lg bg-white rounded-3xl border border-brand-soft shadow-xl p-8" data-testid="verify-seal-card">
        <div className="flex items-center gap-2 text-brand-limeDark mb-6">
          <Home className="w-5 h-5" /><span className="text-sm font-semibold">360immoinvest · Vérification d'authenticité</span>
        </div>

        {state === "checking" && (
          <div className="text-center py-10 text-brand-green/60">
            <Loader2 className="w-10 h-10 mx-auto mb-3 animate-spin" /> Vérification du cachet d'horodatage...
          </div>
        )}

        {state === "valid" && (
          <div data-testid="verify-valid">
            <div className="text-center mb-6">
              <div className="w-16 h-16 rounded-full bg-brand-lime/30 flex items-center justify-center mx-auto mb-3">
                <ShieldCheck className="w-9 h-9 text-brand-greenDeep" />
              </div>
              <h1 className="font-display text-2xl font-semibold text-brand-greenDeep">Document authentique</h1>
              <p className="text-sm text-brand-green/60 mt-1">Le cachet d'horodatage est valide et n'a pas été altéré.</p>
            </div>
            <div className="rounded-2xl bg-brand-softer p-5 text-sm space-y-2">
              <Row label="Logement" value={data.property_name} />
              <Row label="Signataire" value={data.signer_name} />
              <Row label="Signé le" value={data.signed_at} />
              <Row label="Scellé le (UTC)" value={data.sealed_at} />
              <div>
                <p className="text-brand-green/50 mb-1">Empreinte du cachet (SHA-256)</p>
                <p className="font-mono text-xs break-all text-brand-greenDeep bg-white rounded-lg p-2 border border-brand-soft">{data.seal_hash}</p>
              </div>
            </div>
          </div>
        )}

        {state === "invalid" && (
          <div className="text-center py-8" data-testid="verify-invalid">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-3">
              <ShieldX className="w-9 h-9 text-red-600" />
            </div>
            <h1 className="font-display text-2xl font-semibold text-red-600">Cachet invalide</h1>
            <p className="text-sm text-brand-green/60 mt-1">L'empreinte ne correspond pas. Le document a peut-être été modifié.</p>
          </div>
        )}

        {state === "notfound" && (
          <div className="text-center py-8" data-testid="verify-notfound">
            <div className="w-16 h-16 rounded-full bg-brand-soft flex items-center justify-center mx-auto mb-3">
              <ShieldX className="w-9 h-9 text-brand-green/50" />
            </div>
            <h1 className="font-display text-2xl font-semibold text-brand-greenDeep">Aucun cachet trouvé</h1>
            <p className="text-sm text-brand-green/60 mt-1">Ce lien ne correspond à aucun bail signé et scellé.</p>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <p className="flex justify-between gap-4">
      <span className="text-brand-green/50">{label}</span>
      <span className="font-medium text-brand-greenDeep text-right">{value || "—"}</span>
    </p>
  );
}
